module.exports = __webpack_public_path__ + "img/rank_gold.595efc53.png";